import { createComponent } from '@carvana/merch-components';

export const Banner = createComponent('div', {
  className: `
    fixed
    top-0
    z-[900]
    grid
    h-[78px]
    w-screen
    max-w-[1440px]
    grid-cols-1
    items-center
    justify-center
    bg-blue-4
    px-12
    m:px-72
    l:grid-cols-[auto_1fr]
    l:px-20
  `
});

export const Top = createComponent('div', {
  className:
    'hidden grid-flow-col items-center gap-8 uppercase text-white tl-header-s l:grid'
});

export const SearchBarWrapper = createComponent('div', {
  className: 'mx-auto w-full l:max-w-[850px]'
});
